import { type InsuranceCorporateIdentity } from "../types";

export function MahleLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.2325 213.1V299H79.9193V237.072H95.0445V299H118.731V237.072H133V299H156.687V213.1H56.2325Z"
        fill="#002E6D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M172.098 213.1V299H195.784V278.738H214.334V299H238.021V213.1H172.098ZM195.784 254.48V237.072H214.334V254.48H195.784Z"
        fill="#002E6D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M298.237 213.1V244.207H276.833V213.1H253.146V299H276.833V268.179H298.237V299H322.209V213.1H298.237Z"
        fill="#002E6D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M360.165 275.028V213.1H336.478V299H389.273V275.028H360.165Z"
        fill="#002E6D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M455.768 234.218V213.1H399.833V299H455.768V275.313H423.519V265.325H455.768V244.207H423.519V234.218H455.768Z"
        fill="#002E6D"
      />
    </svg>
  );
}

export const Mahle: InsuranceCorporateIdentity = {
  id: "mahle",
  name: "Mahle",
  logo: MahleLogo,
  backgroundColor: "#41B6E6",
  textColor: "#FFFFFF",
  wildcard: "mahle",
  type: "statutory",
};
